/**
 * jj-analytics-events.js (3.7.11)
 * ---------------------------------------------------------------------------
 * Listens to theme events and pushes custom dataLayer events for GTM.
 * Every push carries sale_of_data_allowed from window.jjPrivacy
 * (snippets/jj-privacy-bridge.liquid) so GTM can gate ad tags on it.
 *
 *   samples:added             -> jj_samples_added
 *   seating-calculator:added  -> jj_seating_calculator_add_to_cart
 *   seating-calculator:result -> jj_seating_calculator_result
 *                                (debounced 1.5s, de-duped per page view)
 *
 * Money values are in dollars (Shopify cart JSON is in cents).
 * Loaded deferred on every page from layout/theme.liquid.
 */
(function () {
  'use strict';
  if (window.__jjAnalyticsEvents) return;
  window.__jjAnalyticsEvents = true;

  var w = window;
  w.dataLayer = w.dataLayer || [];

  function currency(cart) {
    return (cart && cart.currency) || (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'USD';
  }
  function dollars(cents) {
    var n = Number(cents);
    return isFinite(n) ? Math.round(n) / 100 : 0;
  }
  function allowed() {
    var p = w.jjPrivacy;
    if (p && typeof p.saleOfDataAllowed === 'boolean') return p.saleOfDataAllowed;
    return !navigator.globalPrivacyControl;
  }
  /** Push after the bridge is ready so sale_of_data_allowed is final. */
  function push(data) {
    function go() {
      data.sale_of_data_allowed = allowed();
      w.dataLayer.push(data);
    }
    if (w.jjPrivacy && typeof w.jjPrivacy.whenReady === 'function') w.jjPrivacy.whenReady(go);
    else go();
  }
  function lineItem(line) {
    var qty = Number(line.quantity) || 0;
    var finalLine = line.final_line_price != null ? line.final_line_price : (line.final_price || line.price || 0) * qty;
    var original = line.original_line_price != null ? line.original_line_price : (line.original_price || line.price || 0) * qty;
    return {
      item_id: line.sku || String(line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      item_variant: line.variant_title || '',
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      variant_id: line.variant_id || line.id || null,
      product_id: line.product_id || null,
      price: qty ? dollars(finalLine / qty) : dollars(line.final_price || line.price),
      quantity: qty,
      discount: dollars(Math.max(0, original - finalLine)),
    };
  }

  /* -------- samples drawer -------- */
  document.addEventListener('samples:added', function (e) {
    var d = e.detail || {};
    var ids = (d.variantIds || []).map(String);
    var lines = ((d.cart && d.cart.items) || []).filter(function (l) {
      return ids.indexOf(String(l.variant_id || l.id)) !== -1;
    });
    var items = lines.map(lineItem);
    push({
      event: 'jj_samples_added',
      currency: currency(d.cart),
      sample_count: ids.length,
      value: items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0),
      items: items,
    });
  });

  /* -------- seating calculator: add to cart -------- */
  document.addEventListener('seating-calculator:added', function (e) {
    var d = e.detail || {};
    var items = (d.items || []).map(lineItem);
    var value = 0;
    var discount = 0;
    items.forEach(function (i) {
      value += i.price * i.quantity;
      discount += i.discount;
    });
    push({
      event: 'jj_seating_calculator_add_to_cart',
      add_type: d.withTable ? 'table_and_chairs' : 'chairs',
      currency: currency(d.cart),
      value: Math.round(value * 100) / 100,
      discount: Math.round(discount * 100) / 100,
      items: items,
    });
  });

  /* -------- seating calculator: result shown -------- */
  var resultTimer = null;
  var lastKey = null;
  document.addEventListener('seating-calculator:result', function (e) {
    var d = e.detail || {};
    clearTimeout(resultTimer);
    resultTimer = setTimeout(function () {
      var key = JSON.stringify([d.shape, d.sizes, d.chair_width, d.comfortable, d.cozy]);
      if (key === lastKey) return;
      lastKey = key;
      push({
        event: 'jj_seating_calculator_result',
        table_shape: d.shape || null,
        table_sizes: d.sizes || {},
        chair_width: d.chair_width || null,
        chair: d.chair || null,
        seats_comfortable: d.comfortable,
        seats_max: d.cozy,
      });
    }, 1500);
  });
})();
